// ============================================================
// コマツバラ形成外科クリニック
// 今すぐ購入 — カートに追加してそのまま /checkout へ
// ネイティブ payment_button の代替。既存カートを消さずに
// 現在の商品を追加してからチェックアウトページへ遷移する。
// ============================================================

// ブラウザの戻るボタンでbfcacheから復元された際にボタンをリセットする
window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    document.querySelectorAll('.komatsubara-buy-now-btn').forEach((btn) => {
      /** @type {HTMLButtonElement} */ (btn).disabled = false;
      btn.textContent = '今すぐ購入';
    });
  }
});

document.addEventListener('click', async (e) => {
  const btn = /** @type {HTMLButtonElement | null} */ (e.target.closest('.komatsubara-buy-now-btn'));
  if (!btn || btn.disabled) return;

  e.preventDefault();

  const productForm = /** @type {HTMLElement | null} */ (btn.closest('product-form-component'));
  if (!productForm) return;

  const variantInput = /** @type {HTMLInputElement | null} */ (productForm.querySelector('input[ref="variantId"]'));
  const quantityInput = /** @type {HTMLInputElement | null} */ (productForm.querySelector('input[ref="quantityInput"]'));

  const variantId = parseInt(variantInput?.value || '0');
  const quantity = parseInt(quantityInput?.value || '1');

  if (!variantId) return;

  // 購入上限と在庫上限の小さい方を実効上限とする
  const maxPerProduct = parseInt(productForm.dataset.maxPerProduct || '3');
  const inventoryMax = quantityInput?.max ? parseInt(quantityInput.max) : maxPerProduct;
  const effectiveMax = Math.min(maxPerProduct, inventoryMax);

  btn.disabled = true;
  const originalText = btn.textContent ?? '今すぐ購入';
  btn.textContent = '処理中...';

  try {
    // 現在のカート内の数量をサーバーから取得して正確に検証
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const cartItem = cart.items.find(/** @param {{ variant_id: number }} item */ (item) => item.variant_id === variantId);
    const cartQty = cartItem ? cartItem.quantity : 0;

    // 追加可能な残り枠を計算
    const canAdd = Math.max(0, effectiveMax - cartQty);

    if (canAdd === 0) {
      // すでにカートが上限に達している場合はそのままチェックアウトへ
      window.location.href = '/checkout';
      return;
    }

    // 上限を超えないよう追加数を調整（例: 残り1枠で2個選択中 → 1個だけ追加）
    const addQuantity = Math.min(quantity, canAdd);

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: addQuantity }),
    });

    if (!addRes.ok) {
      const data = await addRes.json();
      throw new Error(data.description || 'カートへの追加に失敗しました');
    }

    window.location.href = '/checkout';
  } catch (err) {
    btn.disabled = false;
    btn.textContent = originalText;
    alert(err instanceof Error ? err.message : 'エラーが発生しました。もう一度お試しください。');
  }
});
